<template>
  <div class="tw-px-6 tw-py-3" v-if="totalSteps > 0">
    <span class="tw-text-progress tw-font-bold tw-text-xl tw-block tw-mb-2 tw-text-left">
      {{ currentStep }}/{{ totalSteps }}
    </span>
    <div class="tw-flex tw-gap-1">
      <div
        v-for="i in totalSteps"
        :key="i"
        class="tw-h-1 tw-flex-1 tw-rounded-sm"
        :class="segmentClass(i)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreparationProgressBar',
  methods: {
    segmentClass(i) {
      if (i === this.currentStep) return 'tw-bg-segment-active';
      if (i < this.currentStep) return 'tw-bg-segment-active tw-opacity-40';
      return 'tw-bg-segment-inactive';
    },
  },
  computed: {
    preparationModules() {
      const { modules } = this.$store.state.exam;
      return modules.filter(
        m => (m.key && m.key.endsWith('INSTR')) || m.key === '0IN',
      );
    },
    totalSteps() {
      return this.preparationModules.length;
    },
    currentStep() {
      const { module: currentModuleIndex } = this.$store.state.exam.current;
      const currentModule = this.$store.state.exam.modules[currentModuleIndex];
      if (!currentModule) return 0;

      const index = this.preparationModules.indexOf(currentModule);
      return index >= 0 ? index + 1 : 0;
    },
  },
};
</script>
